import React, { FC } from 'react'
import { FieldMetaProps } from 'formik'
import { FieldError, FormLabel } from '@pandiafi/design-system'
import classNames from 'classnames'

import styles from './FormFieldWrapper.module.scss'
import { FORM_FIELD_VALIDATION_ERROR_CLASSNAME } from './FormFieldConstants'

export interface Props {
  name: string
  label?: string
  ariaLabel?: string
  className?: string
  required?: boolean
  children?: React.ReactNode
  meta?: FieldMetaProps<unknown>
  labelLocation?: 'default' | 'left'
  labelBold?: boolean
  labelNormal?: boolean
  labelAddon?: React.ReactNode
  description?: string
}

const FormFieldWrapper: FC<Props> = ({
  name,
  label,
  ariaLabel,
  className,
  children,
  meta,
  required = false,
  labelLocation = 'default',
  labelBold = false,
  labelNormal = false,
  labelAddon,
  description,
}) => {
  return (
    <div
      className={classNames(
        styles.FormFieldWrapper,
        {
          [styles.withLabelOnLeft]: labelLocation === 'left',
        },
        className
      )}
    >
      {label && (
        <>
          <FormLabel
            for={name}
            ariaLabel={ariaLabel}
            required={required}
            className={classNames(styles.FormLabel, {
              [styles.labelOnLeft]: labelLocation === 'left',
              [styles.labelBold]: labelBold,
              [styles.labelNormal]: labelNormal,
              [styles.labelWithAddon]: labelAddon,
            })}
          >
            {label}
          </FormLabel>
          {labelAddon}
        </>
      )}
      <div>
        {children}
        {meta && !!meta.touched && !!meta.error ? (
          <div
            // this custom classname is used for querySelector
            className={FORM_FIELD_VALIDATION_ERROR_CLASSNAME}
            aria-live="assertive"
            aria-atomic="true"
          >
            <FieldError
              error={meta.error}
              aria-label={`${label} - ${meta.error}`}
            />
          </div>
        ) : null}
        {description && (
          <p className="mt-1 text-sm text-gray-600">{description}</p>
        )}
      </div>
    </div>
  )
}

export default FormFieldWrapper
